<% if (Anvil.page.modal.issue.link == 'aee') { %>
<%- include('/ui/form', {
	params: [ 'issue_link_aee', Anvil.page.modal.issue ],
	fields: [
		{
			type: 'select',
			name: 'aee_id',
			title: 'Pénztárgép',
			params: {
				maxItems: 1,
				options: Anvil.page.modal.aees.data.filter(x => x.company_id == Anvil.page.modal.issue.company_id && x.terminal_id == Anvil.page.modal.issue.terminal_id),
				valueField: 'id',
				labelField: 'ap',
				searchField: [ 'ap' ],
				render: {
					item: (item, esc) => `<div>${esc(item.ap)}</div>`,
					option: (item, esc) => `<div class="option">${esc(item.ap)}</div>`
				}
			},
			unset_value: null,
			attributes: Anvil.page.modal.issue.closed ? { disabled: 'disabled' } : null
		}
	]
}) %>
<% } %>